<template>
  <v-container id="user-profile" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" lg="12" md="12">
        <base-material-card
          icon="mdi-card-text-outline"
          :title="bill_id ? $i18n.t('Edit Bill') : $i18n.t('Add Bill')"
          class="px-3 py-1 small-icon"
        >
          <v-btn
            style="position: absolute; right: 0px; top: -10px"
            x-small
            color="blue"
            v-if="bill_id"
            href="/bill/create"
            >+ Add New</v-btn
          >
          <v-btn
            style="position: absolute; right: 0px"
            x-small
            color="grey"
            v-if="bill.status == 0"
            >Open</v-btn
          >
          <v-btn
            style="position: absolute; right: 0px"
            x-small
            color="cyan"
            v-if="bill.status == 1"
            >Partially Paid</v-btn
          >
          <v-btn
            style="position: absolute; right: 0px"
            x-small
            color="green"
            v-if="bill.status == 2"
            >Paid</v-btn
          >
          <v-form id="form" v-model="isValid">
            <v-col>
              <v-row>
                <v-col cols="12" sm="12" md="8" lg="8">
                  <!-- <v-card> -->
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    lg="12"
                    style="padding: 27px"
                  >
                    <v-row>
                      <v-col cols="12" md="6">
                        <z-vendor-select
                          :label="$i18n.t('Service Provider')"
                          v-model="bill.vendor_id"
                          :disabled="isEdit"
                          autocomplete="off"
                        ></z-vendor-select>
                      </v-col>
                    </v-row>

                    <v-row v-if="bill.vendor_id">
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <v-text-field
                          :label="$i18n.t('Bill No.')"
                          v-model="bill.billNo"
                        />
                      </v-col>

                      <v-col cols="12" sm="12" md="6" lg="6">
                        <v-text-field
                          :label="$i18n.t('Order No.')"
                          v-model="bill.orderNo"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <z-date-picker
                          :label="$i18n.t('Bill Date')"
                          v-model="bill.billDate"
                        />
                      </v-col>

                      <v-col cols="12" sm="6" md="4" lg="4">
                        <z-date-picker
                          :label="$i18n.t('Due Date')"
                          v-model="bill.dueDate"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-text-field
                          v-model="bill.title"
                          :label="$i18n.t('Title')"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="6" md="4" lg="4">
                        <v-textarea
                          :label="$i18n.t('Details')"
                          v-model="bill.desc"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- </v-card> -->
                </v-col>

                <v-col cols="12" sm="12" md="4" lg="4">
                  <!-- <v-card> -->
                  <v-btn
                    color="blue-grey lighten-3"
                    small
                    class="bill-left-headers"
                  >
                    <h3>{{ $i18n.t("Attachments") }}</h3>
                  </v-btn>
                  <v-row style="padding: 10px 10px">
                    <v-file-input
                      chips
                      label="Attachment"
                      @change="handleFileUpload()"
                      v-model="file"
                    ></v-file-input>
                  </v-row>
                  <v-row style="padding: 10px 10px">
                    <!-- <v-container class="fill-height" fluid> -->
                    <v-fade-transition mode="out-in">
                      <v-row key="0">
                        <v-col
                          cols="12"
                          sm="12"
                          md="6"
                          lg="6"
                          v-for="(picture, index) in bill.attachments"
                          :key="index"
                        >
                          <v-card>
                            <z-confirm-button
                              fab
                              color="red"
                              x-small
                              class="image-remove"
                              :message="$i18n.t('Remove Image ?')"
                              @click="removePic(picture.time)"
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </z-confirm-button>
                            <a :href="picture.url">
                              <v-img
                                v-if="isPDF(picture.url)"
                                src="@/assets/pdf_format.png"
                                aspect-ratio="1"
                                class="grey darken-4"
                              ></v-img>
                              <v-img
                                v-else
                                :src="picture.url"
                                aspect-ratio="2"
                                class="grey darken-4"
                              ></v-img>
                            </a>
                            <v-row class="px-2">
                              <!-- <v-col cols="12" md="12" lg="12">{{picture.name}}</v-col> -->
                              <v-col cols="12" md="12" lg="12">
                                <!-- {{picture.desc}}{{picture.by}}  -->
                                {{ picture.time | moment("HH:mm DD MMM YYYY") }}
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-fade-transition>
                    <!-- </v-container> -->
                  </v-row>
                  <!-- </v-card> -->
                </v-col>
              </v-row>

              <v-row v-show="bill.vendor_id">
                <v-col cols="12">
                  <!-- <v-card> -->
                  <v-btn
                    color="blue-grey lighten-3"
                    small
                    class="bill-left-headers"
                  >
                    <h3>{{ $i18n.t("Items") }}</h3>
                  </v-btn>
                  <v-btn
                    color="blue"
                    x-small
                    style="float: right"
                    @click="
                      bill.items.push({
                        isAbs: null,
                        cost: null,
                        tax: null,
                        total: null,
                        unitCost: null,
                        units: null,
                        taxAmount: null,
                      })
                    "
                    class="bill-right-headers"
                    >{{ $i18n.t("Add") }}
                  </v-btn>
                  <z-trip-select
                    v-if="bill.vendor_id"
                    forBill="true"
                    style="float: right"
                    :supplier_id="bill.vendor_id"
                    :statuses="'3,4,5,12'"
                    :trips="tripList"
                    @selectedTrip="selectedTrip"
                    btn
                  >
                    <v-btn color="blue" x-small class="bill-right-headers">
                      {{ $i18n.t("Add Trips(s)") }}
                    </v-btn>
                  </z-trip-select>
                  <z-invoice-select
                    v-if="bill.vendor_id"
                    style="float: right"
                    :supplier_id="bill.vendor_id"
                    :statuses="'1,2'"
                    :invoices="invoiceList"
                    @selectedInvoices="selectedInvoices"
                    btn
                  >
                    <v-btn color="blue" x-small class="bill-right-headers">
                      {{ $i18n.t("Add Invoices(s)") }}
                    </v-btn>
                  </z-invoice-select>
                  <v-simple-table dense class="table-border">
                    <template>
                      <thead>
                        <tr>
                          <th class="text-left">{{ $i18n.t("Title") }}</th>
                          <th class="text-left">{{ $i18n.t("Account") }}</th>
                          <th class="text-left">
                            {{ $i18n.t("Unit Cost") }}
                          </th>
                          <th class="text-left">{{ $i18n.t("Units") }}</th>
                          <th class="text-right">{{ $i18n.t("Cost") }}</th>
                          <th class="text-left">{{ $i18n.t("Tax") }}</th>
                          <th class="text-right">
                            {{ $i18n.t("Tax Amount") }}
                          </th>
                          <th class="text-right">{{ $i18n.t("Total") }}</th>
                          <th class="text-right"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in bill.items" :key="index">
                          <td class="text-right">
                            <v-row>
                              <v-col cols="12">
                                <v-row
                                  ><v-text-field v-model="item.title"
                                /></v-row>
                                <v-row style="position: absolute">
                                  <a
                                    v-if="item.trip_id"
                                    :href="'/trip/' + item.trip_id"
                                    target="_blank"
                                    style="margin-top: -22px"
                                    >Trip</a
                                  >
                                  <a
                                    v-if="item.invoice_id"
                                    :href="
                                      '/sales/invoice/' + item.invoice_id
                                    "
                                    target="_blank"
                                    style="margin-top: -22px"
                                    >Invoice</a
                                  >
                                </v-row>
                              </v-col>
                            </v-row>
                          </td>
                          <td class="text-right">
                            <z-account-select v-model="item.accountCode" />
                          </td>
                          <td class="text-right">
                            <v-text-field
                              v-model="item.unitCost"
                              type="number"
                              @change="itemCostByUnits(item)"
                            />
                          </td>
                          <td class="text-right">
                            <v-text-field
                              v-model="item.units"
                              type="number"
                              @change="itemCostByUnits(item)"
                            />
                          </td>
                          <td class="text-right">{{ item.cost }}</td>
                          <td class="text-right">
                            <v-row>
                              <v-col cols="8"
                                ><v-text-field
                                  v-model="item.tax"
                                  type="number"
                                  @change="itemTaxAmount(item)"
                              /></v-col>
                              <v-col cols="4" style="align-self: center"
                                ><v-btn
                                  :color="item.isAbs ? 'cyan' : 'teel'"
                                  x-small
                                  @click="
                                    item.isAbs == null || item.isAbs == false
                                      ? (item.isAbs = true)
                                      : (item.isAbs = null);
                                    itemTaxAmount(item);
                                  "
                                >
                                  {{ item.isAbs ? "/-" : "%" }}
                                </v-btn></v-col
                              >
                            </v-row>
                          </td>
                          <td class="text-right">{{ item.taxAmount }}</td>
                          <td class="text-right">{{ item.total }}</td>
                          <td>
                            <v-btn
                              color="red"
                              fab
                              text
                              @click="removeItem(bill.items, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right" colspan="6">
                            {{ $i18n.t("Total") }}
                          </td>
                          <td class="text-right">
                            {{ bill.fare.totalTaxes }}
                          </td>
                          <td class="text-right">{{ bill.fare.subTotal }}</td>
                          <td class="text-right"></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <!-- </v-card> -->
                </v-col>
              </v-row>

              <v-row v-show="bill.vendor_id">
                <v-col cols="12">
                  <!-- <v-card> -->
                  <v-btn
                    color="blue-grey lighten-3"
                    small
                    class="bill-left-headers"
                  >
                    <h3>{{ $i18n.t("Deductions") }}</h3>
                  </v-btn>
                  <v-btn
                    color="blue"
                    x-small
                    style="float: right"
                    @click="
                      bill.fare.discounts.push({
                        unitCost: null,
                        units: null,
                        amount: null,
                      })
                    "
                    class="bill-right-headers"
                    >{{ $i18n.t("Add") }}
                  </v-btn>
                  <z-fuel-select
                    v-if="bill.vendor_id"
                    style="float: right"
                    :supplier_id="bill.vendor_id"
                    :fuels="discount_ids"
                    @selectedFuels="selectedFuels"
                    btn
                  >
                    <v-btn color="blue" x-small class="bill-right-headers">
                      {{ $i18n.t("Add Fuel(s)") }}
                    </v-btn>
                  </z-fuel-select>
                  <z-expense-select
                    v-if="bill.vendor_id"
                    style="float: right"
                    :supplier_id="bill.vendor_id"
                    :expenses="discount_ids"
                    @selectedExpenses="selectedExpenses"
                    btn
                  >
                    <v-btn color="blue" x-small class="bill-right-headers">
                      {{ $i18n.t("Add Expense(s)") }}
                    </v-btn>
                  </z-expense-select>
                  <v-simple-table dense class="table-border">
                    <template>
                      <thead>
                        <tr>
                          <th class="text-left">{{ $i18n.t("Title") }}</th>
                          <th class="text-left">
                            {{ $i18n.t("Unit Cost") }}
                          </th>
                          <th class="text-left">{{ $i18n.t("Units") }}</th>
                          <th class="text-right">{{ $i18n.t("Total") }}</th>
                          <th class="text-right"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in bill.fare.discounts"
                          :key="index"
                        >
                          <td class="text-right">
                            <v-row>
                              <v-col cols="12">
                                <v-row
                                  ><v-text-field v-model="item.name"
                                /></v-row>
                                <v-row style="position: absolute">
                                  <a
                                    v-if="item.entity_id && item.desc == 'Fuel'"
                                    :href="'/fuel/' + item.entity_id"
                                    target="_blank"
                                    style="margin-top: -22px"
                                    >{{ item.desc }}</a
                                  >
                                  <a
                                    v-if="
                                      item.entity_id && item.desc == 'Expense'
                                    "
                                    :href="'/expense/' + item.entity_id"
                                    target="_blank"
                                    style="margin-top: -22px"
                                    >{{ item.desc }}</a
                                  >
                                </v-row>
                              </v-col>
                            </v-row>
                          </td>
                          <td class="text-right">
                            <v-text-field
                              v-model="item.unitCost"
                              type="number"
                              @change="itemCostByUnits_discount(item)"
                            />
                          </td>
                          <td class="text-right">
                            <v-text-field
                              v-model="item.units"
                              type="number"
                              @change="itemCostByUnits_discount(item)"
                            />
                          </td>
                          <td class="text-right">{{ item.amount }}</td>
                          <td>
                            <v-btn
                              color="red"
                              fab
                              text
                              @click="removeItem(bill.fare.discounts, index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                        <tr>
                          <td class="text-right" colspan="3"></td>
                          <td class="text-right">
                            {{ bill.fare.totalDiscounts }}
                          </td>
                          <td class="text-right"></td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <!-- </v-card> -->
                </v-col>
              </v-row>

              <v-row v-show="bill.vendor_id">
                <v-col cols="12" sm="12" md="12" lg="12">
                  <v-row>
                    <v-col cols="12" sm="6" md="4" lg="4"
                      ><z-currency-select
                        :label="$i18n.t('Currency')"
                        v-model="bill.fare.currency"
                    /></v-col>
                    <v-col
                      cols="12"
                      sm="6"
                      md="4"
                      lg="4"
                      style="align-self: center"
                      >{{ $i18n.t("Total") }} : {{ bill.fare.total }}</v-col
                    >
                  </v-row>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="text-right">
              <v-btn
                color="green"
                class="mr-0"
                v-on:click="saveBill()"
                :loading="loading"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import auth from "@/store/user/module/auth";

@Component({
  name: "BillEdit",
  props: {
    newBill: {
      default: null,
    },
    vendor_id: {
      default: null,
    },
    fetchBills: {
      default: null,
    },
    billDialog: {
      default: null,
    },
  },
})
export default class BillEdit extends Vue {
  isValid = true;
  isEdit = false;
  file = null;
  bill_id = null;
  permitTypes = [];
  taxSlabs = [];
  webcontent = {};
  tripList = "";
  invoiceList = "";
  discount_ids = "";
  bill = {
    vendor_id: null,
    billNo: null,
    orderNo: null,
    billDate: null,
    dueDate: null,
    desc: null,
    items: [],
    discounts: [],
    fare: { currency: null, discounts: [] },
  };

  paymentTerms = [
    {
      text: "Due On Receipt",
      value: "Due On Receipt",
    },
    {
      text: "Net 7",
      value: "Net 7",
    },
    {
      text: "Net 15",
      value: "Net 15",
    },
    {
      text: "Net 30",
      value: "Net 30",
    },
    {
      text: "Net 60",
      value: "Net 60",
    },
    {
      text: "End Of Month",
      value: "End Of Month",
    },
    {
      text: "End Of Next Month",
      value: "End Of Next Month",
    },
  ];

  isPDF(_url) {
    if (_url && _url.includes(".pdf")) {
      return true;
    }
    return false;
  }

  get loading() {
    return common.loading;
  }

  async saveBill() {
    try {
      common.setLoading(true);
      const formData = new FormData();
      const billData = JSON.stringify(this.bill);
      formData.set("data", billData);
      if (this.file) {
        formData.append("file", this.file);
      }
      const bill = await doPostForm("/api/bill/save/return", formData);
      if (this.newBill) {
        this.$emit("fetchBills", true);
        this.$emit("billDialog", false);
      } else {
        if (!this.bill_id) this.$router.push("/bill/" + bill._id);
        this.bill_id = bill._id;
        this.get();
        common.showMessage("Saved Successfully");
      }
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  postFetchDetail(_bill) {
    if (_bill) {
      if (!_bill.vendor_id) _bill.vendor_id = null;
      if (!_bill.billNo) _bill.billNo = null;
      if (!_bill.orderNo) _bill.orderNo = null;
      if (!_bill.billDate) _bill.billDate = null;
      if (!_bill.dueDate) _bill.dueDate = null;
      if (!_bill.pymtTerms) _bill.pymtTerms = null;
      if (!_bill.items) _bill.items = [];
      if (!_bill.discounts) _bill.discounts = [];
      if (!_bill.fare) _bill.fare = {};
      if (!_bill.fare.discounts) _bill.fare.discounts = [];
      if (_bill.items) {
        for (let i = 0; i < _bill.items.length; i++) {
          _bill.items[i].isAbs = _bill.items[i].isAbs
            ? _bill.items[i].isAbs
            : null;
        }
      }
    }
  }

  async get() {
    try {
      const bill = await doGet("/api/bill/" + this.bill_id + "/detail");
      this.postFetchDetail(bill);
      this.file = null;
      this.bill = bill;
      this.bill_id = this.bill._id;
      this.isEdit = true;
      this.populateTrip_ids();
      this.populateInvoice_ids();
      this.populateDiscount_ids();
    } catch (e) {
      common.setError(e.message);
    }
  }

  async removePic(_time) {
    try {
      common.setLoading(true);
      await doGet(
        "/api/bill/" + this.bill_id + "/receipt/" + _time + "/delete"
      );
      this.get();
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async mounted() {
    await auth.doPostLogin();

    this.webcontent = auth.authContent;

    if (this.newBill) {
      this.bill.vendor_id = this.vendor_id;
    } else {
      if (this.$route.params.id) {
        this.bill_id = this.$route.params.id;
        await this.get();
      } else {
        this.bill.fare.currency = this.webcontent.currencies[0];
      }
    }
  }

  handleFileUpload(files) {
    if (files) {
      this.file = files[0];
    }
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  itemTotal(item) {
    if (this.isSet(item.taxAmount) && this.isSet(item.cost)) {
      item.total =
        Math.round((parseFloat(item.taxAmount) + parseFloat(item.cost)) * 100) /
        100;
    } else if (this.isSet(item.taxAmount) && !this.isSet(item.cost)) {
      item.total = Math.round(parseFloat(item.taxAmount) * 100) / 100;
    } else if (!this.isSet(item.taxAmount) && this.isSet(item.cost)) {
      item.total = Math.round(parseFloat(item.cost) * 100) / 100;
    } else {
      item.total = 0;
    }
  }

  totalDiscountByItems(bill) {
    let allD = 0;
    if (bill && bill.fare && this.isSet(bill.fare.discounts)) {
      for (let i = 0; i < bill.fare.discounts.length; i++) {
        allD = parseFloat(allD) + parseFloat(bill.fare.discounts[i].amount);
      }
    }
    bill.fare.totalDiscounts = Math.round(parseFloat(allD) * 100) / 100;
    this.totalFareByItems(bill);
  }

  itemCostByUnits(item) {
    if (this.isSet(item.unitCost) && this.isSet(item.units)) {
      item.cost =
        Math.round(parseFloat(item.unitCost) * parseFloat(item.units) * 100) /
        100;
    } else {
      item.cost = 0;
    }
    this.itemTaxAmount(item);
    this.itemTotal(item);
    this.subTotalFareByItems(this.bill);
    this.totalFareByItems(this.bill);
  }

  itemCostByUnits_discount(item) {
    if (this.isSet(item.unitCost) && this.isSet(item.units)) {
      item.amount =
        Math.round(parseFloat(item.unitCost) * parseFloat(item.units) * 100) /
        100;
    } else {
      item.amount = 0;
    }
    this.itemTotal(item);
    this.totalDiscountByItems(this.bill);
  }

  itemTaxAmount(item) {
    if (this.isSet(item.tax)) {
      if (item.isAbs) {
        item.taxAmount = Math.round(parseFloat(item.tax) * 100) / 100;
      } else {
        if (item.cost) {
          item.taxAmount =
            Math.round(
              parseFloat(item.tax) * 0.01 * parseFloat(item.cost) * 100
            ) / 100;
        } else {
          item.taxAmount = 0;
        }
      }
    } else {
      item.taxAmount = 0;
    }
    this.itemTotal(item);
    this.subTotalFareByItems(this.bill);
    this.totalFareByItems(this.bill);
    this.totalTaxByItems(this.bill);
  }

  subTotalFareByItems(bill) {
    let subT = 0;
    if (bill && this.isSet(bill.items)) {
      for (let i = 0; i < bill.items.length; i++) {
        subT = parseFloat(subT) + parseFloat(bill.items[i].total);
      }
    }
    bill.fare.subTotal = Math.round(subT * 100) / 100;
  }

  totalFareByItems(bill) {
    let allT = 0;
    if (this.isSet(bill.fare.subTotal)) {
      allT = parseFloat(bill.fare.subTotal);
    }
    if (this.isSet(bill.fare.totalDiscounts)) {
      bill.fare.total =
        Math.round(
          (parseFloat(allT) - parseFloat(bill.fare.totalDiscounts)) * 100
        ) / 100;
    } else {
      bill.fare.total = Math.round(parseFloat(allT) * 100) / 100;
    }
  }

  totalTaxByItems(bill) {
    let tT = 0;
    if (bill && this.isSet(bill.items)) {
      for (let i = 0; i < bill.items.length; i++) {
        tT = parseFloat(tT) + parseFloat(bill.items[i].taxAmount);
      }
    }
    bill.fare.totalTaxes = Math.round(parseFloat(tT) * 100) / 100;
  }

  totalFareByTax(bill) {
    if (bill) {
      if (this.isSet(bill.fare.subTotal)) {
        if (bill.fareIncludeTax) {
          bill.fare.total =
            Math.round(parseFloat(bill.fare.subTotal) * 100) / 100;
          bill.tax_id = null;
        } else {
          let taxObj = null;
          if (this.isSet(bill.tax_id)) {
            for (let i = 0; i < this.taxSlabs.length; i++) {
              if (this.taxSlabs[i]._id == bill.tax_id) {
                taxObj = this.taxSlabs[i];
                break;
              }
            }
          }
          if (taxObj && this.isSet(taxObj.amount)) {
            if (taxObj.isAbs) {
              bill.fare.total =
                parseFloat(bill.fare.subTotal) + parseFloat(taxObj.amount);
            } else {
              bill.fare.total =
                Math.round(
                  parseFloat(taxObj.amount) *
                    0.01 *
                    parseFloat(bill.fare.subTotal) *
                    100
                ) /
                  100 +
                parseFloat(bill.fare.subTotal);
            }
          } else {
            bill.fare.total = 0;
          }
        }
      } else {
        bill.fare.total = 0;
      }
    }
  }

  remove(list, index) {
    if (list && index != null && index != undefined) {
      list.splice(index, 1);
    }
  }

  removeItem(list, index) {
    this.remove(list, index);
    this.subTotalFareByItems(this.bill);
    this.totalFareByItems(this.bill);
    this.totalTaxByItems(this.bill);
    this.totalDiscountByItems(this.bill);

    this.populateTrip_ids();
    this.populateInvoice_ids();
    this.populateDiscount_ids();
  }

  populateInvoice_ids() {
    this.invoiceList = "";
    if (this.bill.items) {
      for (let i = 0; i < this.bill.items.length; i++) {
        if (this.bill.items[i].invoice_id) {
          this.invoiceList =
            this.invoiceList + this.bill.items[i].invoice_id + ",";
        }
      }
    }
  }

  selectedInvoices(_invoices) {
    if (_invoices) {
      const vendor_id = this.bill.vendor_id;
      const myCorp_id = this.webcontent.corp_id;
      for (let index = 0; index < _invoices.length; index++) {
        const invoice = _invoices[index];
        if (
          invoice &&
          invoice.client_id == myCorp_id &&
          invoice.vendor_id == vendor_id
        ) {
          const singleItem = {};
          singleItem.title = invoice.invoiceNo + "-" + invoice.statusMessage;
          singleItem.invoice_id = invoice._id;
          singleItem.accountCode = "SupplierPayment";

          const fare = invoice.fare;

          if (!fare) {
            common.setError("Supplier fare not present in trip");
            return false;
          }
          if (!this.bill.fare.currency) {
            this.bill.fare.currency = fare.currency;
          } else if (this.bill.fare.currency != fare.currency) {
            common.setError(
              "Currency mismatch in booking " +
                invoice.invoiceNo +
                ". " +
                fare.currency +
                "!"
            );
            return false;
          }
          singleItem.unitCost = fare.subTotal;
          singleItem.units = 1;
          if (fare) {
            singleItem.tax = fare.totalTaxes;
          }
          singleItem.isAbs = true;
          this.itemTaxAmount(singleItem);
          this.bill.items.push(singleItem);
          this.itemCostByUnits(singleItem);
          this.populateInvoice_ids();
        }
      }
    }
  }

  populateTrip_ids() {
    this.tripList = "";
    if (this.bill.items) {
      for (let i = 0; i < this.bill.items.length; i++) {
        if (this.bill.items[i].trip_id) {
          this.tripList = this.tripList + this.bill.items[i].trip_id + ",";
        }
      }
    }
  }

  selectedTrip(_trips) {
    if (_trips) {
      const vendor_id = this.bill.vendor_id;
      const myCorp_id = this.webcontent.corp_id;
      for (let index = 0; index < _trips.length; index++) {
        const trip = _trips[index];
        const singleItem = {};
        singleItem.title = trip.tripNo + "-" + trip.statusStr;
        singleItem.trip_id = trip._id;
        singleItem.accountCode = "SupplierPayment";

        let fare = null;
        if (trip.billings) {
          for (let j = 0; j < trip.billings.length; j++) {
            const billing = trip.billings[j];
            if (
              billing &&
              billing.client_id == myCorp_id &&
              billing.vendor_id == vendor_id
            ) {
              fare = billing.fare;
            }
          }
        }

        if (!fare) {
          common.setError("Supplier fare not present in trip");
          return false;
        }
        if (!this.bill.fare.currency) {
          this.bill.fare.currency = fare.currency;
        } else if (this.bill.fare.currency != fare.currency) {
          common.setError(
            "Currency mismatch in booking " +
              trip.tripNo +
              ". " +
              fare.currency +
              "!"
          );
          return false;
        }
        singleItem.unitCost = fare.subTotal;
        singleItem.units = 1;
        if (fare) {
          singleItem.tax = fare.totalTaxes;
        }
        singleItem.isAbs = true;
        this.itemTaxAmount(singleItem);
        this.bill.items.push(singleItem);
        this.itemCostByUnits(singleItem);
      }
      this.populateTrip_ids();
    }
  }

  populateDiscount_ids() {
    this.discount_ids = "";
    if (this.bill.fare && this.bill.fare.discounts) {
      for (let i = 0; i < this.bill.fare.discounts.length; i++) {
        if (this.bill.fare.discounts[i].entity_id) {
          this.discount_ids =
            this.discount_ids + this.bill.fare.discounts[i].entity_id + ",";
        }
      }
    }
  }

  selectedFuels(_fuels) {
    if (_fuels) {
      for (let index = 0; index < _fuels.length; index++) {
        const fuel = _fuels[index];
        const singleItem = {};
        singleItem.name = fuel.receiptNo;
        singleItem.desc = "Fuel";
        singleItem.entity_id = fuel._id;
        singleItem.accountCode = "SupplierPayment";

        if (!this.bill.fare.currency) {
          this.bill.fare.currency = fuel.currency;
        } else if (this.bill.fare.currency != fuel.currency) {
          common.setError(
            "Currency mismatch in booking " +
              fuel.receiptNo +
              ". " +
              fuel.currency +
              "!"
          );
          return false;
        }
        singleItem.unitCost = fuel.cost;
        singleItem.units = 1;
        this.itemCostByUnits_discount(singleItem);
        this.bill.fare.discounts.push(singleItem);
        this.totalDiscountByItems(this.bill);
      }
      this.populateDiscount_ids();
    }
  }

  selectedExpenses(_expenses) {
    if (_expenses) {
      for (let index = 0; index < _expenses.length; index++) {
        const expense = _expenses[index];
        const singleItem = {};
        singleItem.name = expense.title;
        singleItem.desc = "Expense";
        singleItem.entity_id = expense._id;
        singleItem.accountCode = "SupplierPayment";

        if (!this.bill.fare.currency) {
          this.bill.fare.currency = expense.fare.currency;
        } else if (this.bill.fare.currency != expense.fare.currency) {
          common.setError(
            "Currency mismatch in booking " +
              expense.title +
              ". " +
              expense.fare.currency +
              "!"
          );
          return false;
        }
        singleItem.unitCost = expense.fare.total;
        singleItem.units = 1;
        this.itemCostByUnits_discount(singleItem);
        this.bill.fare.discounts.push(singleItem);
        this.totalDiscountByItems(this.bill);
      }
      this.populateDiscount_ids();
    }
  }
}
</script>
<style scoped>
.bill-left-headers {
  text-transform: none;
  top: 16px;
  left: 10px;
  font-size: 12px;
}
.bill-right-headers {
  text-transform: none;
  top: 20px;
  right: 0px;
  font-size: 12px;
}
.image-download {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: #42a5f5;
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.image-remove {
  position: absolute;
  z-index: 1;
  text-transform: none;
  color: red;
  top: 4px;
  right: -12px;
  font-size: 12px;
}
.table-border {
  border: 1px #dbdbdb solid;
  padding: 10px;
}
</style>
